import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Autosuggest from 'react-autosuggest';
import { Popper, Paper } from '@mui/material';
import { get } from 'lodash';

import { autosuggestStyles } from '../../Form/RenderAutocomplete';
import MenuItem from '../../MenuItem/MenuItem';
import TextField from '../../TextField/TextField';

import { fetchAdvancedSearchSuggestions, removeAdvancedSearchSuggestions } from '../actions';

const popperStyle = {
  zIndex: 1400,
};

class ValueEditorAutocompleteComponent extends React.Component {
  anchorEl = null;

  setAnchorEl = (node) => {
    this.anchorEl = node;
  };

  componentDidMount() {
    this.props.getSuggestions('');
  }

  componentWillUnmount() {
    this.props.removeSuggestions();
  }

  onSuggestionsFetchRequested = ({ value, reason }) => {
    if (reason === 'input-changed') {
      this.props.getSuggestions(value);
    }
  };

  onSuggestionsClearRequested = () => {};

  getSuggestionValue = ({ label }) => label;

  renderSuggestion = ({ label }, { isHighlighted }) => {
    const text = `${label || 'empty'}`;

    return (
      <MenuItem selected={isHighlighted} style={autosuggestStyles.itemStyle} component="div" title={text} key={text}>
        {text}
      </MenuItem>
    );
  };

  onInputChange = (event, { newValue }) => {
    this.props.onChange(newValue);
  };

  renderInputComponent = ({ inputRef = () => {}, onFocus, onBlur, ref, ...other }) => (
    <TextField
      {...other}
      style={this.props.inputStyle}
      InputProps={{
        onBlur,
        onFocus,
        inputRef: (node) => {
          ref(node);
          inputRef(node);
        },
      }}
    />
  );

  renderSuggestionsContainer = (options) => {
    const paperStyle = {
      maxHeight: '500px',
      overflowY: 'auto',
      width: this.anchorEl ? this.anchorEl.clientWidth : undefined,
    };

    return (
      <Popper style={popperStyle} anchorEl={this.anchorEl} open={Boolean(options.children)}>
        <Paper square {...options.containerProps} style={paperStyle}>
          {options.children}
        </Paper>
      </Popper>
    );
  };

  render() {
    return (
      <Autosuggest
        suggestions={this.props.suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={this.getSuggestionValue}
        renderSuggestion={this.renderSuggestion}
        renderInputComponent={this.renderInputComponent}
        theme={{
          suggestionsContainerOpen: autosuggestStyles.suggestionsContainerOpen,
          suggestionsList: autosuggestStyles.suggestionsList,
          suggestion: autosuggestStyles.suggestion,
        }}
        renderSuggestionsContainer={this.renderSuggestionsContainer}
        inputProps={{
          placeholder: 'Start type',
          value: this.props.value,
          disabled: this.props.disabled,
          onChange: this.onInputChange,
          inputRef: (node) => this.setAnchorEl(node),
        }}
      />
    );
  }
}

ValueEditorAutocompleteComponent.propTypes = {
  field: PropTypes.string,
  value: PropTypes.any,
  suggestions: PropTypes.array,
  inputStyle: PropTypes.object,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  getSuggestions: PropTypes.func,
  removeSuggestions: PropTypes.func,
};

const mapStateToProps = (state, { field }) => ({
  suggestions: get(state.advancedSearch, ['suggestions', field], []),
});

const mapDispatchToProps = (dispatch, { field }) => ({
  getSuggestions: (value) => dispatch(fetchAdvancedSearchSuggestions(field, value)),
  removeSuggestions: () => dispatch(removeAdvancedSearchSuggestions(field)),
});

export const ValueEditorAutocomplete = connect(mapStateToProps, mapDispatchToProps)(ValueEditorAutocompleteComponent);
